"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _rater = require("@/api/rater");
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _lifehikesInitData = require("@/lifehikes-init-data");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'rulelist',
  data() {
    return {
      dialogCreateFormVisible: false,
      dialogUpdateFormVisible: false,
      loading: false,
      query: {
        page: 1,
        limit: 200,
        sort: 'sort',
        type: 'rater-assignment'
      },
      newSetting: {
        "type": "rater-assignment",
        "rule": {
          "applyTo": "",
          "value": 300
        },
        "description": "Maximium number of video for rating per rater per week",
        "sort": 1
      },
      updatedSetting: null,
      raterRules: null,
      defaultRule: null,
      raterList: null
    };
  },
  created() {
    this.getList();
    this.getRaterList();
  },
  methods: {
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.raterRules = [];
      (0, _rater.getRuleList)(token, this.query).then(response => {
        const data = response.data;
        var tmpRaterRules = _.filter(data.rows, function (o) {
          return !(o.rule.applyTo === 'all');
        });
        this.defaultRule = _.filter(data.rows, function (o) {
          return o.rule.applyTo === 'all';
        });

        // filter out not a rater
        for (var i = 0; i < tmpRaterRules.length; i++) {
          console.log('rater uuid:', tmpRaterRules[i].rule.applyTo);
          var rater = _.find(this.raterList, function (u) {
            return u.user === tmpRaterRules[i].rule.applyTo;
          });
          if (rater) {
            this.raterRules.push(tmpRaterRules[i]);
          }
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('page-question-save-err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getRaterList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 200,
        role: 'otr-rater',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.raterList = response.data.rows.map(s => {
          return {
            user: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    getUserName(uuid) {
      var staff = this.raterList ? this.raterList.find(u => u.user === uuid) : "-";
      if (staff) {
        return staff.name ? staff.name : '-';
      } else {
        return 'Not a rater';
      }
    },
    isRater(uuid) {
      var staff = this.raterList ? this.raterList.find(u => u.user === uuid) : "-";
      if (staff) return "";else return "not-a-rater";
    },
    update(rule) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      (0, _rater.updateRule)(token, rule).then(response => {
        //this.raterRules[0] = response.data
        (0, _log.displayPopupMessage)('Rater weekly credit setting updated successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'Rule', `${_lifehikesInitData.userEvent.raterAssignment.updateIndividualRule}`, email, `ID: ${response.data.id}`);
        this.getList();
        this.dialogUpdateFormVisible = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    create(rule) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      (0, _rater.createRule)(token, rule).then(response => {
        (0, _log.displayPopupMessage)('Rater weekly credit setting created successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'Rule', `${_lifehikesInitData.userEvent.raterAssignment.addIndividualRule}`, email, `ID: ${response.data.id}`);
        this.getList();
        this.dialogCreateFormVisible = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    confirmEdit(rule) {
      this.dialogUpdateFormVisible = true;
      this.updatedSetting = rule;
    }
  }
};